(function (Translator) {
    // lv
    Translator.add("address", "Adrese:", "PayseraMapBundle", "lv");
    Translator.add("friday", "Piektdiena", "PayseraMapBundle", "lv");
    Translator.add("monday", "Pirmdiena", "PayseraMapBundle", "lv");
    Translator.add("no_results", "Nekas netika atrasts", "PayseraMapBundle", "lv");
    Translator.add("saturday", "Sestdiena", "PayseraMapBundle", "lv");
    Translator.add("search_placeholder", "Ievadiet fragmentu", "PayseraMapBundle", "lv");
    Translator.add("service.cash_in", "Skaidras naudas iemaksa", "PayseraMapBundle", "lv");
    Translator.add("service.cash_out", "Skaidras naudas izmaksa ", "PayseraMapBundle", "lv");
    Translator.add("service.identification", "Identifik\u0101cija", "PayseraMapBundle", "lv");
    Translator.add("service.pay", "Maks\u0101jumi", "PayseraMapBundle", "lv");
    Translator.add("services", "Pakalpojumi:", "PayseraMapBundle", "lv");
    Translator.add("sunday", "Sv\u0113tdiena", "PayseraMapBundle", "lv");
    Translator.add("thursday", "Ceturtdiena", "PayseraMapBundle", "lv");
    Translator.add("tuesday", "Otrdiena", "PayseraMapBundle", "lv");
    Translator.add("wednesday", "Tre\u0161diena", "PayseraMapBundle", "lv");
    Translator.add("working_hours", "Darba laiks:", "PayseraMapBundle", "lv");
})(Translator);
